import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cbd8072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-brand" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, null, -1))
const _hoisted_5 = { class: "login-user-box" }
const _hoisted_6 = { class: "login-user is-pc" }
const _hoisted_7 = { class: "login-user is-sp" }
const _hoisted_8 = { class: "main" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "HOME", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "従事者予定", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "従事者実績", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "児童予定・実績", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "各種マスタ管理", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "管理業務", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "ログアウト", -1))


//import { useStore } from 'vuex';
import router from '@/router/index';
import { getLoginUser, logout } from '@/utility/login';
//import { setStoreBCode, setStoreTargetDate } from '@/utility/Store';
//import { toDate } from '@/utility/date';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminHeader',
  props: {
    mode: null
  },
  setup(__props: any) {



const publicPath = process.env.BASE_URL;
const user = getLoginUser();
// const store = useStore();

function dLogout() {
  //  Page遷移に利用したパラメータをクリア
  //  setStoreBCode(store, '');
  //  setStoreTargetDate(store, toDate(new Date()));
  //  login画面に移動 写真一覧画面のログアウト時に 一部ユーザーで例外スローが起こるため 2025/2/6

  logout();
  router.push({ name: 'admin-login' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(__props.mode)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: `${_unref(publicPath)}img/logo.png`
        }, null, 8, _hoisted_3)
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(user)?.staffName), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(user)?.staffName), 1)
      ])
    ]),
    _createElementVNode("nav", _hoisted_8, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          (_unref(user)?.browsingAuthority.motionAndStatic! > 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "home",
                to: { name: 'home' }
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          (_unref(user)?.browsingAuthority.scheduleOfWorkers! > 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "shift-plan",
                to: { name: 'shift-plan-daily' }
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _hoisted_12
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          (_unref(user)?.browsingAuthority.employeePerformance! > 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "shift-results",
                to: { name: 'shift-results-daily' }
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          (_unref(user)?.browsingAuthority.childrenScheduleAchieveme! > 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "children",
                to: { name: 'children-daily' }
              }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _hoisted_16
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          (_unref(user)?.browsingAuthority.employeeMaster! > 0 || _unref(user)?.browsingAuthority.childMaster! > 0 || _unref(user)?.browsingAuthority.eventMaster! > 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "master",
                to: { name: 'master' }
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          (_unref(user)?.browsingAuthority.bambooOutput! > 0)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "mgmt",
                to: { name: 'mgmt' }
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _hoisted_20
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            class: "logout",
            to: { name: 'admin-login' },
            onClick: dLogout
          }, {
            default: _withCtx(() => [
              _hoisted_21,
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}
}

})